/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState, lazy } from "react";
import { Button, Nav, Navbar } from "react-bootstrap";
import styled from "styled-components";
import Classes from "./header.css";
import parser from "html-react-parser";
import UserWayAccessibilityMenu from "../../components/UserWayAccessibilityMenu";

const ProductsHeader = lazy(() => import("../Menubar/ProductsHeader"));

const NavWrapper = styled.div`
  /* Scoped styles using component wrapper */
  &.header-navbar-component {
    .navbar-dark .navbar-nav .nav-link {
      color: white;
      z-index: 1200;
      white-space: nowrap;
      text-decoration: none;
    }

    @media(min-width:992px) {
      .navbar-dark .navbar-nav .nav-link {
        margin: 0px 2rem;
      }
      .navbar-expand-lg .navbar-nav {
        margin-left: 0rem;
      }
    }

    .navbar-expand-lg .navbar-nav .dropdown-menu {
      margin: 0px 0px 0 -30px;
    }

    ._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
      font-weight: 600;
    }

    .dropdown-item.active, 
    .dropdown-item:active {
      color: #083F88;
      text-decoration: none;
      background-color: transparent;
      border-left: 4px solid #083F88;
      border-right: 4px solid #083F88;
      transition: all 0.1s linear;
      border-radius: 2px;
    }

    .dropdown-item {
      border-bottom: 2px solid transparent;
      color: #083f88;
    }

    .dropdown-item:focus, 
    .dropdown-item:hover {
      background-color: rgba(0, 170, 228, 0.3);
      color: #083f88;
      border-radius: 5px;
      border-bottom: unset;
    }

    @media(max-width:767px) {
      .dropdown-item {
        border-bottom: 0px transparent;
      }
      .dropdown-item:hover {
        border-bottom: 0px transparent;
      }
    }

    #dropdown-item-button::after {
      content: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA8ElEQVQ4jWNgGAUowHLOVSHjmc+4cMkbz3zGZTnnqhCyGBOMYTD/vsDvP2w7mf5/26E99SoPNs2M/79s+vWHbZ/xzJsiGAaw/PpbycDAYPKf4b8tFzPbRmSXGM98xsX0/+tmBgZGZ0YGBn1GBuZSuD4Y4z/DhxoGBj5VRgbGwP8MDE5Ql3hxsAj+Y/z/ZdN/BkYniErGrR9+/q+D6WNEdeYZVob/fCsZGRgDoZL7IIYzOEHo/+sZGD+Fn003+Y3VAGyGIADj1g+//gffyVP9iSKKbgB2Q7BrxmkAqiFMbLg0EwTGM8+wGs88w0qyxqEFAFtSY2S3+RTSAAAAAElFTkSuQmCC");
      vertical-align: -0.09em;
      border: none;
      margin-top: 5px;
    }

    .show > .btn-primary.dropdown-toggle:focus {
      box-shadow: none;
      border-color: white;
    }

    .btn-primary:focus {
      border-color: white;
    }

    .btn-primary:not(:disabled):not(.disabled):active, 
    .show > .btn-primary.dropdown-toggle {
      background: #fff;
      color: #0481b5;
      border: 1px solid #fff;
      box-shadow: none;
    }

    .btn-primary:not(:disabled):not(.disabled).active:focus, 
    .btn-primary:not(:disabled):not(.disabled):active:focus, 
    .show > .btn-primary.dropdown-toggle:focus {
      background: #fff;
      color: #0481b5;
      border: 1px solid #fff;
      box-shadow: none;
    }

    &.channelsNav {
      .dropdown-submenu-container a.dropdown-submenu::after {
        position: absolute;
        right: 0;
        top: 0;
      }

      .dropdown-menu {
        .dropdown-toggle::after {
          content: ">";
          vertical-align: middle;
          border: none;
          margin-top: 4px;
          font-weight: 600;
          color: #dddd;
          transform: rotate(0);
        }
        padding-right: 15px;
      }
    }

    @media(min-width:992px) and (max-width:1067px) {
      .eEKJvu ._3yQ6ipwnXEJX5uUyBeOBFR.btn.btn-primary.btn-md {
        font-weight: 600;
        font-size: 14px;
      }
    }

    @media(max-width:992px) {
      .navbar-dark .navbar-toggler {
        background-color: #00AAE4;
      }
    }
  }
`;

const StyledNavbar = styled(Navbar)`
  background: transparent !important;
  z-index: 999;
  box-shadow: none;
  padding-right: 1em;
  padding-top: 1em;
  transition: all .3s ease-in;

  &.active {
    background: #083F88 !important;
    padding-bottom: 0px;
  }

  .navbar-toggler-icon {
    background-image: url("https://d2w24n4g34usfg.cloudfront.net/realtor-cobranding/togglericon.webp");
  }

  .main_logo {
    width: 230px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }

  .trust_logo {
    height: 50px;
    width: 55px;
  }

  .nav-link {
    font-family: "Poppins";
    font-weight: 700;
  }

  .dropdown-toggle::after {
    content: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAdklEQVQ4je3QsQ6CQBCEYRpiQigI8aV5GSpKrqG18Y0+G43H5RaxNHHa2flnd5vmr50wojvwO4yROeCGDX0QXnHHtQaYvJXyTZ7hlPlTDdBizoY29FnzSwsu0RklJBXNM9roRxHkc/MJyPlwBfJ9uIAc3/z7egC+KuGQHgx9zAAAAABJRU5ErkJggg==);
    border: none;
    vertical-align: -0.09em;
    margin-top: 0px;
    display: inline-block;
    margin-left: 0.255em;
  }

  @media (min-width: 992px) {
    .navbar-expand-lg .navbar-collapse {
      justify-content: space-around;
    }

    .main_logo {
      margin-left: 2rem;
    }

    .navbar-brand {
      margin-left: 3rem;
    }
  }

  @media (max-width: 991px) {
    padding-top: unset;

    &.navbarTransition {
      transform: translateY(-100%);
      transition: all .3s ease-in;
    }

    .navbar-toggler {
      border: none;
      background-color: #083f88;
    }

    .navbar-nav {
      padding: 0.5rem 1.5rem;
      background-color: #083f88;
    }

    .navbar-dark .navbar-toggler {
      background-color: unset;
    }

    .navbar-collapse {
      z-index: 10;
    }
  }

  @media (max-width: 767px) {
    .main_logo {
      width: 150px;
      height: auto;
    }

    .trust_logo {
      width: 45px;
      height: 40px;
    }
  }

  @media (max-width: 320px) {
    .main_logo {
      width: 132px;
      margin-left: 0.5rem;
      margin-top: 0.5rem;
    }
  }

  @media (min-width: 321px) and (max-width: 374.9px) {
    .main_logo {
      margin-left: 0.2rem;
      margin-top: 0.25rem;
    }
  }

  @media (min-width: 375px) and (max-width: 767.9px) {
    .main_logo {
      margin-left: 0.2rem;
      margin-top: 0.5rem;
    }
  }

  @media (min-width: 768px) and (max-width: 1195px) {
    .main_logo {
      margin-left: unset;
    }
  }

  @media (min-width: 1200px) and (max-width: 1399.9px) {
    .main_logo {
      margin-left: auto;
    }
  }

  @media (min-width: 1499px) and (max-width: 1699.9px) {
    .main_logo {
      margin-left: 5rem;
    }
  }

  @media only screen and (min-width: 992px) and (max-width: 1200px) {
    .navbar-dark .navbar-nav .nav-link {
      margin: 0px 1rem;
    }
  }
`;

function isMobileOrTablet() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isMobile = width < 768 && height < 1024;

    if (isMobile) {
        return true;
    } else {
        return false;
    }
}

const HeaderNavbar = ({
    aiBrandingData,
    loanOfficerActive,
    loanOfficerData
}) => {
    const [navbar, setNavbar] = useState(false);
    const isMobileOrTabletDevice = isMobileOrTablet();
    const imgURL = process.env.REACT_APP_CDN_LINK;

    let prevScrollPos = window.scrollY;

    window.onscroll = function () {
        const currentScrollPos = window.scrollY;
        const menuNavbar = document.getElementById("navbar");

        if (currentScrollPos === 0) {
            menuNavbar?.classList.remove("navbarTransition");
            setNavbar(false);
        } else {
            if (prevScrollPos > currentScrollPos) {
                setNavbar(true);
            } else if (prevScrollPos < currentScrollPos) {
                if (!isMobileOrTabletDevice) {
                    setNavbar(true);
                } else {
                    setNavbar(false);
                    menuNavbar?.classList.add("navbarTransition");
                }
            }
        }

        prevScrollPos = currentScrollPos;
    };

    return (
        <div className="header-navbar-component">
            <NavWrapper className="header-navbar-component">
                <StyledNavbar
                    id="navbar"
                    expand="lg"
                    fixed="top"
                    bg="dark"
                    variant="dark"
                    className={navbar ? "navbar active" : "navbar"}
                >
                    <Navbar.Brand>
                        <div className="d-flex">
                            <div>
                                <a
                                    href="https://www.swmc.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Sunwest Mortgage Company, Inc."
                                    aria-label="Sunwest mortgage Company, Inc."
                                >
                                    <img
                                        src={process.env.REACT_APP_CDN_LINK + "swmc-images/sunwest-trust-white-logo.png"}
                                        className="main_logo img-fluid"
                                        alt="SWMC Logo"
                                        title="SWMC Logo"
                                        aria-label="SWMC Logo"
                                    />
                                </a>
                            </div>
                            <UserWayAccessibilityMenu color="white" width={40} height={40} />
                        </div>
                    </Navbar.Brand>

                    <Navbar.Brand>
                        <ProductsHeader />
                    </Navbar.Brand>

                </StyledNavbar>
            </NavWrapper>
        </div>
    );
};

export default HeaderNavbar;